import {useEffect, useState} from 'react';
import {useLocation, useNavigate, Outlet} from 'react-router-dom';

import styles from './styles/admin-layout.module.css';

import ModeModal from './ModeModal';

import {ReactComponent as DashboardIcon} from '../../assets/design-system/dashboard.svg';
import {ReactComponent as DashboardWidth2Icon} from '../../assets/design-system/dashboard-width-2.svg';
import {ReactComponent as DatabaseIcon} from '../../assets/design-system/database.svg';
import {ReactComponent as DatabaseWidth2Icon} from '../../assets/design-system/database-width-2.svg';
import {ReactComponent as DocsIcon} from '../../assets/design-system/docs.svg';
import {ReactComponent as DocsWidth2Icon} from '../../assets/design-system/docs-width-2.svg';
import {ReactComponent as FeedbackIcon} from '../../assets/design-system/feedback.svg';
import {ReactComponent as FeedbackWidth2Icon} from '../../assets/design-system/feedback-width-2.svg';
import {ReactComponent as VocaIcon} from '../../assets/design-system/voca.svg';
import {ReactComponent as VocaWidth2Icon} from '../../assets/design-system/voca-width-2.svg';
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import {ReactComponent as Logo} from '../../assets/logo/logo.svg';
import {ReactComponent as HomeActive} from '../../assets/menu/home-active.svg';
import {ReactComponent as Home} from '../../assets/menu/home.svg';
import {ReactComponent as LogoutActive} from '../../assets/menu/logout-active.svg';
import {ReactComponent as Logout} from '../../assets/menu/logout.svg';
import {ReactComponent as ArrowRight} from '../../assets/side-bar/arrow-right.svg';

const MenuBox = ({ path, text, icon, activeIcon, isExternalLink, isActive, movePage }) => {
    return (
        <div className={styles.boxMenu} onClick={() => movePage(path, isExternalLink)}>
            {isActive ? activeIcon : icon}
            <p datatype={isActive ? 'active' : 'inactive'}>
                {text}
            </p>
        </div>
    );
};

export default function Layout() {
    const location = useLocation();

    const navigate = useNavigate();

    const [openModeModal, setOpenModeModal] = useState(false);
    const [currentPath, setCurrentPath] = useState('');

    const inactiveColor = 'var(--gray-dark)';
    const activeColor = 'var(--main_purple)';
    
    const modeList = [
        { id: 4, path: '/idea', text: '창의혁신아이디어', icon: <LightbulbOutlinedIcon sx={{ color: '#73757C', fontSize: 20 }} />, activeIcon: <LightbulbOutlinedIcon sx={{ color: activeColor, fontSize: 20 }} /> },
        { id: 1, path: '/chat', text: '사용자 모드', icon: <Home />, activeIcon: <HomeActive /> },
        // { id: 2, path: '/setting', text: '설정', icon: <Setting />, activeIcon: <SettingActive /> },
        { id: 3, path: '', text: '로그아웃', icon: <Logout />, activeIcon: <LogoutActive /> }
    ];

    const menuList = [
        { id: 1, path: '/admin/dashboard', text: '대시보드', icon: <DashboardIcon style={{ color: inactiveColor }} />, activeIcon: <DashboardWidth2Icon style={{ color: activeColor }} />, isExternalLink: false },
        { id: 2, path: '/admin/feedback', text: '피드백', icon: <FeedbackIcon style={{ color: inactiveColor }} />, activeIcon: <FeedbackWidth2Icon style={{ color: activeColor }}/>, isExternalLink: false },
        { id: 7, path: '/admin/faq', text: 'FAQ', icon: <QuestionAnswerOutlinedIcon sx={{ color: inactiveColor, fontSize: 24 }} />, activeIcon: <QuestionAnswerIcon sx={{ color: activeColor, fontSize: 24 }} />, isExternalLink: false },
        { id: 3, path: '/admin/docs', text: '문서', icon: <DocsIcon style={{ color: inactiveColor }} />, activeIcon: <DocsWidth2Icon style={{ color: activeColor }} />, isExternalLink: false },
        // { id: 4, path: '/admin/voca', text: '단어장', icon: <VocaIcon style={{ color: inactiveColor }} />, activeIcon: <VocaWidth2Icon style={{ color: activeColor }} />, isExternalLink: false },
        // { id: 5, path: '/admin/database', text: 'DB', icon: <DatabaseIcon style={{ color: inactiveColor }} />, activeIcon: <DatabaseWidth2Icon style={{ color: activeColor }} />, isExternalLink: false },
        // { id: 6, path: 'https://liambx.com/erd/p/github.com/Dfinite/TPC-H_ERD/blob/main/schema.rb?showMode=ALL_FIELDS', text: 'ERD', icon: <DatabaseIcon style={{ color: inactiveColor }} />, activeIcon: <DatabaseWidth2Icon style={{ color: activeColor }} />, isExternalLink: true }
    ];

    const toggleModeModal = () => {
        setOpenModeModal(!openModeModal);
    };

    const movePage = (path, isExternalLink) => {
        if (isExternalLink) {
            window.open(path, '_blank');
        } else {
            navigate(path);
        }
    };

    const isActiveMenu = (path) => {
        if (currentPath === path) {                                             // 기본 경로
            return true;
        }
        
        if (path === '/admin/docs' && currentPath.startsWith('/admin/docs/')) { // 파라미터 경로 : /admin/docs/{id}
            return true;
        }

        if (path === '/admin/faq' && currentPath.startsWith('/admin/faq')) {    // 파라미터 경로 : /admin/faq/*
            return true;
        }

        return false;
    };

    useEffect(() => {
        setCurrentPath(location.pathname);
    }, [location.pathname]);

    return (
        <div className={styles.wrapper}>
            <div className={styles.sidebar}>
                <Logo onClick={() => navigate('/')} />
                <div className={styles.containerMenu}>
                    {menuList.map((menu) => {
                        const { id, path, text, icon, activeIcon, isExternalLink } = menu;
                        return (
                            <MenuBox
                                key={id}
                                path={path}
                                text={text}
                                icon={icon}
                                activeIcon={activeIcon}
                                isExternalLink={isExternalLink}
                                isActive={isActiveMenu(path)}
                                movePage={movePage}
                            />
                        );
                    })}
                </div>
                <div className={styles.arrowRight} onClick={toggleModeModal}>
                    <ArrowRight  />
                </div>
                {openModeModal &&
                    <ModeModal
                        modeList={modeList}
                        toggleModeModal={toggleModeModal}
                        movePage={movePage}
                    />
                }
            </div>
            <Outlet />
        </div>
    );
}
